import { EventBus } from "../../../eventbus";

export default {
  props: {
    name: String,
    id: String,
    deleteEvent: String,
    updateEvent: String,
    isActive: {
      type: Boolean,
      default: true,
    },
    type: String,
  },
  data() {
    return {
      isDeleting: false,
    };
  },
  methods: {
    deleteTag(e) {
      e.preventDefault();

      this.isDeleting = true;

      EventBus.$emit(this.deleteEvent, { id: this.id });
    },
    updateTag(e) {
      e.preventDefault();

      EventBus.$emit(this.updateEvent, { id: this.id, name: this.name });
    },
  },
};
